<div class="auth-test-container">
  <h2>Azure AD User Delegation Flow Tester</h2>
  
  <!-- Debug Information Panel -->
  <div class="debug-panel" *ngIf="debugInfo">
    <h3>Authentication Debug Info</h3>
    <div class="debug-content">
      <div class="debug-section">
        <h4>Active Account</h4>
        <pre *ngIf="debugInfo.activeAccount">{{ formatJson(debugInfo.activeAccount) }}</pre>
        <p *ngIf="!debugInfo.activeAccount" class="no-account">No active account found. Please login first.</p>
      </div>
      
      <div class="debug-section" *ngIf="debugInfo.currentToken">
        <h4>Current Token Info</h4>
        <pre>{{ formatJson(debugInfo.currentToken) }}</pre>
      </div>
      
      <div class="debug-section">
        <h4>Environment Configuration</h4>
        <pre>{{ formatJson(debugInfo.environment) }}</pre>
      </div>
    </div>
  </div>

  <!-- Test Controls Panel -->
  <div class="test-controls">
    <h3>Test Controls</h3>
    
    <div class="control-section">
      <h4>Scope Testing</h4>
      <div class="scope-selection">
        <label for="scope-select">Select Scope:</label>
        <select id="scope-select" [(ngModel)]="selectedScope">
          <option value="access_as_user">User Access</option>
          <option value="helpdesk">Helpdesk</option>
          <option value="graph">Graph</option>
          <option value="all">All Scopes</option>
        </select>
        <button 
          (click)="testDelegationFlow()" 
          [disabled]="isLoading"
          class="btn btn-primary">
          Test Delegation Flow
        </button>
      </div>
    </div>

    <div class="control-section">
      <h4>Quick Tests</h4>
      <div class="quick-tests">
        <button 
          (click)="testGetTicketPage()" 
          [disabled]="isLoading"
          class="btn btn-test">
          Test GetTicketPage (POST)
        </button>
        
        <button 
          (click)="requestHelpdeskAccess()" 
          [disabled]="isLoading"
          class="btn btn-helpdesk">
          Request Helpdesk Access
        </button>
        
        <button 
          (click)="checkAuthStatus()" 
          [disabled]="isLoading"
          class="btn btn-info">
          Check Auth Status
        </button>
        
        <button 
          (click)="generateCurl()" 
          [disabled]="isLoading"
          class="btn btn-secondary">
          Generate cURL Command
        </button>
      </div>
    </div>

    <div class="control-section">
      <h4>Custom Endpoint Test</h4>
      <div class="custom-endpoint">
        <input 
          type="text" 
          [(ngModel)]="customEndpoint" 
          placeholder="e.g., Ticket/GetTicketPage"
          class="endpoint-input">
        <button 
          (click)="testCustomEndpoint()" 
          [disabled]="isLoading || !customEndpoint"
          class="btn btn-primary">
          Test Endpoint
        </button>
      </div>
    </div>
  </div>

  <!-- Current Token Display -->
  <div class="token-info" *ngIf="currentTokenInfo">
    <h3>Current Token Information</h3>
    <div class="token-details">
      <div class="token-section">
        <h4>Scopes</h4>
        <ul class="scope-list">
          <li *ngFor="let scope of currentTokenInfo.scopes">{{ scope }}</li>
        </ul>
      </div>
      
      <div class="token-section">
        <h4>Expires On</h4>
        <p>{{ currentTokenInfo.expiresOn }}</p>
      </div>
      
      <div class="token-section">
        <h4>Claims</h4>
        <pre>{{ formatJson(currentTokenInfo.claims) }}</pre>
      </div>
      
      <div class="token-section">
        <h4>Access Token</h4>
        <div class="token-display">
          <textarea readonly [value]="currentTokenInfo.token" class="token-textarea"></textarea>
          <button (click)="copyToClipboard(currentTokenInfo.token || '')" class="btn btn-copy">Copy Token</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Test Results Panel -->
  <div class="test-results">
    <div class="results-header">
      <h3>Test Results</h3>
      <button (click)="clearResults()" class="btn btn-clear">Clear Results</button>
    </div>
    
    <div class="results-list" *ngIf="testResults.length > 0">
      <div
        *ngFor="let result of testResults; let i = index"
        class="result-item"
        [class]="getResultClass(result)">
        
        <div class="result-header">
          <span class="result-status">
            {{ result.success ? '✓' : '✗' }}
          </span>
          <span class="result-message">{{ result.message }}</span>
          <span class="result-code" *ngIf="result.statusCode">
            ({{ result.statusCode }})
          </span>
        </div>
        
        <div class="result-details" *ngIf="result.data">
          <details>
            <summary>Response Data</summary>
            <pre>{{ formatJson(result.data) }}</pre>
          </details>
        </div>
        
        <div class="result-token" *ngIf="result.tokenInfo">
          <details>
            <summary>Token Info</summary>
            <div class="token-info-compact">
              <p><strong>Scopes:</strong> {{ result.tokenInfo.scopes.join(', ') }}</p>
              <p><strong>Expires:</strong> {{ result.tokenInfo.expiresOn }}</p>
              <details>
                <summary>Full Claims</summary>
                <pre>{{ formatJson(result.tokenInfo.claims) }}</pre>
              </details>
            </div>
          </details>
        </div>
      </div>
    </div>
    
    <div class="no-results" *ngIf="testResults.length === 0">
      <p>No test results yet. Run some tests above to see results here.</p>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p>Running test...</p>
    </div>
  </div>
</div>